import { Lightning } from '@lightningjs/sdk'

export default class ImageItemWrapper extends Lightning.Component {
  static _template() {
    return {
      clipbox: true,
      w: w => w,
      h: h => h,
    }
  }

  set item(obj) {
    this._item = obj
  }

  get item() {
    return this._item
  }

  set index(v) {
    this._index = v
  }

  get child() {
    return this.children[0]
  }

  set itemType(v) {
    this._itemType = v
  }

  get itemType() {
    return this._itemType
  }

  set brandName(v) {
    this._brandName = v
  }
  set bgImage(v) {
    this._bgImage = v
  }
  set albumImage(v) {
    this._albumImage = v
  }

  create() {
    const item = this._item
    const index = this._index
    this.children = [
      {
        w: this.w,
        h: this.h,
        type: this._itemType,
        item: item,
        index,
        brandName: this._brandName,
        bgImage: this._bgImage,
        albumImage: this._albumImage,
      },
    ]
    this._itemIsCreated = true

    if (this._notifyOnItemCreation && this.hasFocus()) {
      this._refocus()
    }
  }

  _firstActive() {
    this.create()

    if (!ImageItemWrapper.FIRST_CREATED) {
      // this.fireAncestors('$firstItemCreated')
      ImageItemWrapper.FIRST_CREATED = true
    }
  }

  _inactive() {
    this.childList.clear()
    this._itemIsCreated = false
    this.stage.gc()
  }

  _active() {
    if (!this._itemIsCreated) {
      this.create()
    }
  }

  _getFocused() {
    // due to lazy creation there is the possibility that
    // an component receives focus before the actual item
    // is created, therefore we set a flag
    if (!this.child) {
      this._notifyOnItemCreation = true
    } else {
      return this.child
    }
  }
}
ImageItemWrapper.FIRST_CREATED = false
